import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AllowedTransitions,
  EnumToStatusString,
  IncidentStatusEnum,
  StatusStringToEnum,
} from 'src/app/enums/incidentStatus.enum';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';

@Component({
  selector: 'app-verify-incident-dialog',
  templateUrl: './verify-incident-dialog.component.html',
  styleUrls: ['./verify-incident-dialog.component.scss'],
})
export class VerifyIncidentDialogComponent implements OnInit {
  isAssignedToMe: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<VerifyIncidentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private encryptionService: EncryptionService
  ) {
    let decryptedUserData = this.encryptionService.decrypt(
      localStorage.getItem('UserDetails')
    );
    if (data.assignedUsers != null) {
      let assigneeList: any[] = JSON.parse(data.assignedUsers);
      if (assigneeList.length > 0) {
        assigneeList.forEach((x) => {
          if (
            x.UserId.toLowerCase() === decryptedUserData.UserID.toLowerCase()
          ) {
            this.isAssignedToMe = true; // If a match is found, set to true
          } else {
            this.isAssignedToMe = false;
          }
        });
      }
    }
  }

  statusOptions: string[] = [
    'Open',
    'Close',
    'Verified',
    'Snooze',
    'In-Progress',
    'On-Hold',
    'Approved',
    'Rejected',
    'Completed',
  ];

  statusOptionsAssgined: string[] = [
    'Close',
    'Verified',
    'In-Progress',
    'On-Hold',
    'Completed',
  ];
  private statusIconMap: { [key: string]: string } = {
    Open: 'folder_open',
    Close: 'close',
    Verified: 'verified',
    Snooze: 'snooze',
    'In-Progress': 'sync',
    'On-Hold': 'pause_circle',
    Approved: 'check_circle',
    Rejected: 'cancel',
    Completed: 'task_alt',
  };

  // Status color mapping
  private statusColorMap: { [key: string]: string } = {
    Open: 'bg-blue-100 text-blue-800 border border-blue-200',
    Close: 'bg-gray-100 text-gray-800 border border-gray-200',
    Verified: 'bg-green-100 text-green-800 border border-green-200',
    Snooze: 'bg-yellow-100 text-yellow-800 border border-yellow-200',
    'In-Progress': 'bg-orange-100 text-orange-800 border border-orange-200',
    'On-Hold': 'bg-fuchsia-100 text-fuchsia-800 border border-fuchsia-200', // Light Fuchsia (new)
    Approved: 'bg-emerald-100 text-emerald-800 border border-emerald-200',
    Rejected: 'bg-rose-100 text-rose-800 border border-rose-200', // Light Rose (new)
    Completed: 'bg-purple-100 text-purple-800 border border-purple-200',
  };

  ngOnInit(): void {
    const fromStatusEnum: IncidentStatusEnum = this.data.incidentStatus;
    this.selectedOption = EnumToStatusString[fromStatusEnum];
  }

  selectedOption: string;
  errorMessage: string = '';

  onStatusChange(newStatus: string): void {
    const fromStatusEnum: IncidentStatusEnum = this.data.incidentStatus;
    const toStatusEnum = StatusStringToEnum[newStatus];

    const isValid = AllowedTransitions[fromStatusEnum]?.includes(toStatusEnum);

    if (!isValid) {
      this.errorMessage = `Invalid transition from "${EnumToStatusString[fromStatusEnum]}" to "${newStatus}"`;
      this.selectedOption = ''; // Reset selection
    } else {
      this.errorMessage = '';
      this.selectedOption = newStatus;
    }
  }
  getStatusTagClass(status: string): string {
    return (
      this.statusColorMap[status] ||
      'bg-gray-100 text-gray-800 border border-gray-200'
    );
  }
  getStatusIcon(status: string): string {
    return this.statusIconMap[status] || 'help_outline';
  }
  saveChanges(): void {
    // Final validation before closing
    const fromStatusEnum: IncidentStatusEnum = this.data.incidentStatus;
    const toStatusEnum = StatusStringToEnum[this.selectedOption];

    const isValid = AllowedTransitions[fromStatusEnum]?.includes(toStatusEnum);

    if (!isValid) {
      this.errorMessage = `Invalid transition from "${EnumToStatusString[fromStatusEnum]}" to "${this.selectedOption}"`;
      return;
    }

    this.dialogRef.close(this.selectedOption);
  }
}
